import { useMediaQuery } from '@s_mart/hooks';

export const MOBILE_BREAKPOINT = 768;

export function useIsMobile() {
  const isMenorQue768 = useMediaQuery(`(max-width: ${MOBILE_BREAKPOINT}px)`);

  return isMenorQue768;
}
